/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 使用場所情報
 */
export interface Szoa206aResponseElecAceptSearchResultDtoEmpposInfo {
    /**
     * 使用場所需要家区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C401060」のユーザコードを設定
     */
    empposDmdiv?: string;
    /**
     * 使用場所需要家区分名称：全半角混在
     */
    empposDmdivAname?: string;
    /**
     * 使用場所住所コード：英数字
     */
    empposAddrcd?: string;
    /**
     * 使用場所郵便番号：数字
     */
    empposPostno?: string;
    /**
     * 使用場所都道府県名称：全角
     */
    empposPfcAname?: string;
    /**
     * 使用場所都道府県カナ名称：全角（カナ）
     */
    empposPfcKanaAname?: string;
    /**
     * 使用場所市区郡町村名称：全角
     */
    empposMptAname?: string;
    /**
     * 使用場所市区郡町村カナ名称：全角（カナ）
     */
    empposMptKanaAname?: string;
    /**
     * 使用場所町域名称：全角
     */
    empposTwareaAname?: string;
    /**
     * 使用場所町域カナ名称：全角（カナ）
     */
    empposTwareaKanaAname?: string;
    /**
     * 使用場所大字丁目名称：全角
     */
    empposOazaAname?: string;
    /**
     * 使用場所大字丁目カナ名称：全角（カナ）
     */
    empposOazaKanaAname?: string;
    /**
     * 使用場所番地：数字
     */
    empposBanti?: string;
    /**
     * 使用場所番地区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C008870」のユーザコードを設定
     */
    empposBntdiv?: string;
    /**
     * 使用場所番地区分名称：全半角混在
     */
    empposBntdivAname?: string;
    /**
     * 使用場所番地区分カナ名称：全半角混在
     */
    empposBntdivKanaAname?: string;
    /**
     * 使用場所号：数字
     */
    empposGou?: string;
    /**
     * 使用場所号区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C008880」のユーザコードを設定
     */
    empposGoudiv?: string;
    /**
     * 使用場所号区分名称：全半角混在
     */
    empposGoudivAname?: string;
    /**
     * 使用場所号区分カナ名称：全半角混在
     */
    empposGoudivKanaAname?: string;
    /**
     * 使用場所分筆号：英数字
     */
    empposBunptGou?: string;
    /**
     * 使用場所住宅・棟号漢字名：全角
     */
    empposSupadrAname?: string;
    /**
     * 使用場所住宅・棟号カナ名：全角（カナ/数字/英字/スペース/記号）
     */
    empposSupadrKananm?: string;
    /**
     * 使用場所屋号・業種漢字名：全角
     */
    empposYagouAname?: string;
    /**
     * 使用場所屋号・業種カナ名：全角（カナ/数字/英字/スペース/記号）
     */
    empposYagouKananm?: string;
    /**
     * 使用場所表示住所漢字：全角
     */
    empposAddrAnameF?: string;
    /**
     * 使用場所表示住所カナ：全角
     */
    empposAddrKanaAnameF?: string;
}

